// Services.
import {WaHelperService} from '../../wa-services/wa-helper-service';
import {FactoryService} from '../../wa-services/factory-service';

// Classes.
import {AthleteGeneralInfoItem} from './athlete-general-info.item';
import {RankingItem} from './ranking.item';
import {CategoryItem} from './category.item';


export class AthleteDetailedInfoItem extends AthleteGeneralInfoItem {
  public age: number;
  public worldDebut: number;
  public _worldRank: number;
  public division: string;
  public mainCurrentRanking: RankingItem;
  public mainCategory: CategoryItem;
  public gender: string;

  protected rawBioFields: any[];
  protected rawWorldRankings: any;

  constructor(rawAthleteDetailedInfoItem: any,
    protected waHelperService: WaHelperService,
    protected factory: FactoryService) {
    super(rawAthleteDetailedInfoItem, waHelperService);

    this.age = rawAthleteDetailedInfoItem.Age;
    this.rawBioFields = rawAthleteDetailedInfoItem.BioFields;
    this.gender = rawAthleteDetailedInfoItem.Gender;
    this.rawWorldRankings = rawAthleteDetailedInfoItem.WorldRankings;

    this.processBioFields();

    this.getBestWorldRankingRaw();
  }



  protected processBioFields() {
    let bioFieldsIndexed: {[index: string]: any} = {};

    this.rawBioFields.forEach(bioField => bioFieldsIndexed[bioField.Title] = bioField.Value);

    this.worldDebut = +bioFieldsIndexed['International archery debut'];

    // Free not needed resources.
    delete (this.rawBioFields);

  }


  protected getBestWorldRankingRaw() {
    let current = this.rawWorldRankings.Current;

    if (current) {
      let mainCurrent: any = {};

      current.forEach((ranking: any) => {
        if (typeof mainCurrent.Rnk === 'undefined' || ranking.Rnk < mainCurrent.Rnk) {
          mainCurrent = ranking;
        }
      })

      // Copy CatCode to Cat because RankingItem expects that property
      mainCurrent.Cat = mainCurrent.CatCode;

      this.mainCurrentRanking = this.factory.newRankingItem(mainCurrent);
      this.mainCurrentRanking.athlete = this;
      this.mainCategory = this.waHelperService.getCategoryInfoByCode(this.mainCurrentRanking.catCode);
    }
  }

  public get worldRank(): number {
    return this.mainCurrentRanking.rank;
  }

  public get worldRankLabel(): string {
    return this.mainCurrentRanking.rankLabel;
  }

  public get divisionId(): number {
    return this.mainCategory.divisions[0];
  }

  public get worldDebutLabel(): string {
    return this.worldDebut ? this.worldDebut + '' : '-';
  }

  get ageLabel(): string {
    return this.age ? this.age + '' : '-';
  }

  get genderLabel(): string {
    let label: string;
    switch (this.gender) {
      case 'M':
        label = 'Men';
        break;
      case 'W':
        label = 'Women';
        break;
    }

    return label;
  }

}
